import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const Preview = ({ fileUrl, fileName }) => {
  if (!fileUrl) return null;

  const lowerName = fileName?.toLowerCase() || "";
  const isPdf = lowerName.endsWith(".pdf");
  const isImage =
    lowerName.endsWith(".png") ||
    lowerName.endsWith(".jpg") ||
    lowerName.endsWith(".jpeg") ||
    lowerName.endsWith(".gif");

  // Appending fragments like #toolbar=0 to local blob URLs can cause rendering issues in some browsers.
  // We only append it if it's a remote URL.
  const pdfUrl =
    isPdf && !fileUrl.startsWith("blob:") ? `${fileUrl}#toolbar=0` : fileUrl;

  let content = null;
  if (isPdf) {
    content = (
      <Box sx={{ width: "100%", height: "100%" }}>
        <object data={pdfUrl} type="application/pdf" width="100%" height="100%">
          <iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            title="Document Preview"
            style={{ border: "none" }}
          >
            <Typography sx={{ p: 4, textAlign: "center", color: "#66638C" }}>
              Your browser does not support PDF previews.
              <br />
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#403C6F", textDecoration: "underline" }}
              >
                Click here to view the file
              </a>
            </Typography>
          </iframe>
        </object>
      </Box>
    );
  } else if (isImage) {
    content = (
      <img
        src={fileUrl}
        alt={fileName}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      />
    );
  } else {
    content = (
      <Typography sx={{ color: "#9F9DB6", fontSize: "14px" }}>
        Preview not available for this file type
      </Typography>
    );
  }

  return (
    <Box
      key={fileUrl}
      sx={{
        width: "100%",
        height: { xs: "380px", sm: "480px", md: "calc(78vh - 140px)" },
        minHeight: "350px",
        maxHeight: "650px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: "#F7F8FB",
        borderRadius: "8px",
        border: "1px solid #E8E8E9",
      }}
    >
      {content}
    </Box>
  );
};

Preview.propTypes = {
  fileUrl: PropTypes.string,
  fileName: PropTypes.string,
};

export default Preview;
